jQuery(document).ready(function () {
  var allPanels = $(".accordion .accordion-content").hide();

  jQuery(".accordion .accordion-holder .accordion-btn").click(function () {

    var target = jQuery(this).next();

    var parentList = jQuery(this);



    console.log(parentList);



    if (parentList.hasClass("active")) {

      target.slideUp();

      parentList.removeClass("active");

    } else {

      allPanels.slideUp();

      jQuery(".accordion > .accordion-holder > .accordion-btn").removeClass("active");

      target.slideDown();

      parentList.addClass("active");

    }

    return false;

  });
  
});